import type { ICvoFacilityFeatures } from '$shared/interfaces/ICvoFacilityFeatures';
import BaseModel from './BaseModel';

export class CvoFacilityFeatures extends BaseModel<ICvoFacilityFeatures> {
  public get enrolledInCvoServices(): boolean {
    return !!this.response?.enrolledInCvoServices;
  }
}
